import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { debateFactCheckOthers } from '../../../../../redux/Thunks/debatesThunk'



const argumentData = [
  {
    text : "Argument is Correct",
    value: "correct"
  }, 
  {
    text : "Argument is Incorrect",
    value: "incorrect"
  }
]

function FactCheckForm({data, closeForm}){

    const { debate_id } = useParams()
    const dispatch = useDispatch()

    const [inputValue, setInputValue] = useState({
      source: "",
      argument: "",
    })
  
    const [errorMsg, setErrorMsg] = useState("")
    const [mainErrorMsg, setMainErrorMsg] = useState("")
  
  
    const handleChange = (e) => {
      setMainErrorMsg("")
      setErrorMsg("")
      const {name, value} = e.target
  
      setInputValue((prevValue) => {
        return {
          ...prevValue,
          [name] : value
        }
      })
    }
  
    const handleArgument = (item) => {
      setMainErrorMsg("")
      setErrorMsg("")
      setInputValue((prevValue) => {
        return {
          ...prevValue,
          "argument": item
        }
      })
    }
  
  
  
    const suggestionClick = (e) => {
      e.preventDefault()

      if(inputValue.source && !inputValue.source.startsWith("https")){
        setErrorMsg("You must provide a valid url")
        return
      }

      if(!inputValue.argument){
        setMainErrorMsg("Select an argument")
        return 
      }

      const parentArgumentData = data?.data

      const body = {
        ...inputValue,
        username: parentArgumentData?.user,
        node_id: parentArgumentData?.id,
        debate_id
      }

      dispatch(debateFactCheckOthers(body))

     
  
      setInputValue({
        source: "",
        argument: "",
        })
  
        closeForm()
  
    }
  
  
    return (
      <form className='mt-4 mb-2' onSubmit={suggestionClick}>
      <div className='relative h-[180px]  bg-white rounded-xl'>
      
      <p className='p-3 text-black font-bold'>
      Fact Check Others
      </p>
  
      <p className='text-red-600 my-3 px-3'>{mainErrorMsg}</p>
  
     
       <div className='flex rounded-md bg-[#D9D9D9] space-x-5 w-3/4 px-3'>
        {argumentData.map((item) => {
          return (
          <button  key={item?.text} type="button" 
          onClick={() => {
            handleArgument(item?.value)
          }}
          className={`text-black px-3 border-none hover:border-[0.5px] hover:font-semibold
          ${inputValue.argument === item?.value && "bg-[#474B7D]"}
         hover:bg-[#474B7D] rounded-lg`}>
          {item?.text}
        </button>)
        })}
      </div>

    <div className={`w-3/4 px-3 absolute bottom-3 left-2`}>
 
    <p className='text-red-600 mt-5'>{errorMsg}</p>

    <div className='flex items-center bg-[#D9D9D9] text-black px-3 h-[35px] rounded-md'>
    <label className='font-bold mr-2'>Source:</label>
    <input 
    type='text'
    value={inputValue?.source}
    className='w-full rounded-lg text-xs px-2.5 h-[25px]'
    name="source"
    onChange={handleChange}
    placeholder="Insert link here"
    required
    />
    </div>
      </div>
  
  
      <button className='absolute bg-[#7AA65F] rounded-lg text-sm md:text-lg
                    py-2 px-7 text-white bottom-3 right-2'>
              Send
          </button>
      </div>
  
      </form>
    )
  }

export default FactCheckForm
